<template>
  <div>
    <div class="order_list">
      <div class="label_title">
        訂購清單
      </div>
      <div class="info_area">
        <div style="height: 24px;"/>
        <div class="row no-gutters commodity_label ">
          <div class="col text_style">商品</div>
          <div class="row no-gutters count_area">
            <div class="col-auto text_style">數量</div>
            <div class="col-auto text_style">小計</div>
          </div>
        </div>
        <div class="commodity_label_space"/>
        <div v-for="(item,index) in commodityList" :key="item.id">
          <Commodity style="margin-bottom: 12px" v-model="commodityList[index]"/>
        </div>
        <div style="height: 24px;"/>
        <div v-if="hasAdditions" class="text_style">加購專區</div>
        <div v-if="hasAdditions" style="height: 24px;"/>
        <div v-if="hasAdditions" v-for="(item,index) in additionList" :key="item.id">
          <Commodity style="margin-bottom: 12px" v-model="additionList[index]"/>
        </div>
        <div style="height: 64px;"/>
        <OrderInfo/>
        <div style="height: 64px;"/>
      </div>
      <div class="label_title">
        訂購人資料
      </div>
      <div class="info_area">
        <div style="height: 48px;"/>
        <div class="row no-gutters input_area">
          <div class="text_label">姓名<span class="must">*</span></div>
          <div class="col">
            <input class="input_style" v-model="order.receiver_name" placeholder="請輸入收件人姓名"
                   @blur="validateNull('receiver_name')"/>
            <div v-if="isNotEmpty(errors.receiver_name)" class="error-message">{{ errors.receiver_name }}</div>
          </div>
        </div>
        <div style="height: 24px;"/>
        <div class="row no-gutters input_area">
          <div class="text_label">連絡電話<span class="must">*</span></div>
          <div class="col">
            <input class="input_style" v-model="order.phone_number" placeholder="請輸入收件人連絡電話"
                   @input="limitInput"/>
            <div v-if="isNotEmpty(errors.phone_number)" class="error-message">{{ errors.phone_number }}</div>
          </div>
        </div>
        <div style="height: 24px;"/>
        <div class="row no-gutters input_area">
          <div class="text_label">電子信箱<span class="must">*</span></div>
          <div class="col">
            <input class="input_style" v-model="order.email" placeholder="請輸入收件人電子信箱"/>
            <div v-if="isNotEmpty(errors.email)" class="error-message">{{ errors.email }}</div>
          </div>

        </div>
        <div style="height: 24px;"/>
        <div class="row no-gutters input_area">
          <div class="text_label">收件地址<span class="must">*</span></div>
          <div class="col">
            <input class="input_style" v-model="order.address" placeholder="請輸入收件地址"
                   @blur="validateNull"
            />
            <div v-if="isNotEmpty(errors.address)" class="error-message">{{ errors.address }}</div>
          </div>

        </div>
        <div style="height: 24px;"/>
        <div class="row no-gutters input_area">
          <div class="text_label">備註</div>
          <div class="col">
            <textarea class="input_style " rows="3" v-model="order.note" placeholder="請輸入備註"/>
          </div>

        </div>
        <div style="height: 48px;"/>


        <div class="divider"/>
        <div style="height: 32px;"/>
        <div class="subtotal">

          <div class="row">
            <div class="col subtotal_label">小計</div>
            <div class="price">NT$ {{ priceText }}</div>
          </div>
          <div style="height: 14px"/>
          <div class="row">
            <div class="col subtotal_label">低溫宅配</div>
            <div class="price">NT$ {{ feeText }}</div>
          </div>
          <div style="height: 14px"/>
          <div class="row">
            <div class="col subtotal_label">付款金額總計</div>
            <div class="total_price">NT$ {{ totalPriceText }}</div>
          </div>
          <div style="height: 32px"/>
          <label class="container">我已確認以上資料正確無誤，已閱讀、理解並同意「訂購須知
            <input type="checkbox" value="agree" v-model="checked">
            <span class="checkmark"></span>
          </label>
          <div v-if="errors.checked" class="error-message">{{ errors.checked }}</div>
        </div>
        <div style="height: 32px;"/>
        <div class="divider"/>
        <div style="height: 32px;"/>
        <div class="btn_area">
          <button type="button" class="btn btn_style btn-primary" @click="clickCheck">
            <span class="btn_text">去付款</span>
          </button>
        </div>
        <div style="height: 32px;"/>
      </div>

    </div>
    <Loading/>
  </div>
</template>

<script>
import {checkError, getPrice, isEmpty, wait} from "@/util/helpers";
import {validateEmail, validatePhone} from "@/util/rules";
import Commodity from "../../components/Commodity";
import OrderInfo from "../../components/OrderInfo";
import {getAdditions, getCommodities} from "@/api/commodity";
import {createOrder} from "@/api/api";
import AlertDialog from "../dialog/AlertDialog";
import Loading from "../dialog/Loading";
import {getAnalytics, logEvent} from "firebase/analytics";

export default {
  name: "CreateOrder",
  components: {Loading, Commodity, OrderInfo},
  data() {
    return {
      commodities: [],
      additions: [],
      order: {
        receiver_name: "",
        phone_number: "",
        email: "",
        address: "",
        note: "",
        price: 0,
        shipping_fee: 0,
        shopping_carts: [],
      },
      checked: false,
      commodityList: [],
      additionList: [],
      errors: {
        receiver_name: '',
        phone_number: '',
        email: '',
        address: '',
        checked: '',
        bankAccount: '',
      },
      showButton: true,
    };
  },
  computed: {
    settingData() {
      return this.$store.getters.getSettingData;
    },
    hasAdditions() {
      let val = this.additions;
      return isEmpty(val) === false;
    },
    fee() {
      let val = this.order.shipping_fee;
      return isEmpty(val) ? 0 : val;
    },
    feeText() {
      return getPrice(this.fee);
    },
    price() {
      let commodityPrice = this.commodityList.reduce((total, item) => {
        const price = item.price;
        let q = isEmpty(item.quantity) ? 0 : item.quantity;
        return total + (q * price);
      }, 0);

      let additionPrice = this.additionList.reduce((total, item) => {
        const price = item.price;
        let q = isEmpty(item.quantity) ? 0 : item.quantity;
        return total + (q * price);
      }, 0);

      return commodityPrice + additionPrice;
    }, priceText() {
      return getPrice(this.price);
    },
    totalPrice() {
      let val = this.price + this.fee;
      return isEmpty(val) ? 0 : val;
    },
    totalPriceText() {
      return getPrice(this.totalPrice);
    },
    mainCommodityId() {
      let val = this.settingData.data.main_page_commodity_id;
      return isEmpty(val) ? 0 : val;
    },
    mainCommodityCount() {
      return this.$store.getters.getMainCommodityCount || 0;
    },
  },
  created() {
    this.getCommodities();
    this.getAdditions();
    this.setFee();
  },
  methods: {
    limitInput() {
      this.order.phone_number = this.order.phone_number.replace(/\D/g, '').slice(0, 10);
    },
    async waitForSetting() {
      while (!this.settingData) {
        await wait(100);
      }
    },
    async getCommodities() {
      let response = await getCommodities();
      let val = response.data;
      this.commodityList = isEmpty(val) ? [] : val;
      await this.waitForSetting();
      const item = this.commodityList.find(item => item.id === this.mainCommodityId) || this.commodityList[this.mainCommodityId];
      if (item) item.quantity = this.mainCommodityCount;
    },
    async getAdditions() {
      let response = await getAdditions();
      this.additions = response.data;
      let val = this.additions;
      this.additionList = isEmpty(val) ? [] : val;
      this.$store.dispatch('setMainCommodityCount', null);
    },
    async setFee() {
      await this.waitForSetting();
      this.order.shipping_fee = Number(this.settingData.data.shipping_fee);
    },
    isNotEmpty(val) {
      return isEmpty(val) === false;
    },
    validateNull(type) {
      switch (type) {
        case "receiver_name" :
          if (isEmpty(this.order.receiver_name)) {
            this.errors.receiver_name = '*您尚未填寫資料';
          } else {
            this.errors.receiver_name = '';
          }
          break;
        case "phone_number" :
          if (isEmpty(this.order.phone_number)) {
            this.errors.phone_number = '*您尚未填寫資料';
          } else if (validatePhone(this.order.phone_number)) {
            this.errors.phone_number = "*連絡電話格式錯誤格式錯誤";
          } else {
            this.errors.phone_number = '';
          }
          break;
        case "email" :
          if (isEmpty(this.order.email)) {
            this.errors.email = '*您尚未填寫資料';
          } else if (validateEmail(this.order.email)) {
            this.errors.email = "*電子郵件格式錯誤";
          } else {
            this.errors.email = '';
          }
          break;
        case "address" :
          if (isEmpty(this.order.address)) {
            this.errors.address = '*您尚未填寫資料';
          } else {
            this.errors.address = '';
          }
          break;
        case "checked":
          if (this.checked === false) {
            this.errors.checked = "*請確認訂購須知";
          } else {
            this.errors.checked = '';
          }
          break;
      }
    },
    areAllErrorsEmpty() {
      return Object.values(this.errors).every(value => isEmpty(value));
    },
    isAllQuantityZero() {
      return !this.commodityList.every(item => item.quantity === 0) || !this.additionList.every(item => item.quantity === 0);
    },
    isCommodityLQuantityZero() {
      return !this.commodityList.every(item => item.quantity === 0);
    },
    async clickCheck() {
      this.validateNull('receiver_name');
      this.validateNull('phone_number');
      this.validateNull('email');
      this.validateNull('address');
      this.validateNull('checked');
      let result = this.areAllErrorsEmpty();
      if (result === false) return;
      // 商品數量 都是0  驗證
      result = this.isAllQuantityZero();
      if (result === false) {
        await this.$dialog.show(AlertDialog, {
          text: '請選擇商品數量'
        });
        return;
      }
      result = this.isCommodityLQuantityZero();
      if (result === false) {
        await this.$dialog.show(AlertDialog, {
          text: '不能只購買加購商品'
        });
        return;
      }
      let list = this.commodityList.filter(item => item.quantity > 0);
      let shopping_carts = list.map(item => ({
        commodity_id: item.id,
        price: item.price,
        amount: item.quantity,
        subtotal: item.price * item.quantity,
        category: 'product',
      }));
      list = this.additionList.filter(item => item.quantity > 0);

      let additions = list.map(item => ({
        commodity_id: item.id,
        price: item.price,
        amount: item.quantity,
        subtotal: item.price * item.quantity,
        category: 'addition',
      }));

      shopping_carts = shopping_carts.concat(additions);
      this.order.price = this.totalPrice;
      this.order.shopping_carts = shopping_carts.map(e => {
        return {
          ...e,
          category: undefined,
        }
      });

      try {
        await this.$store.dispatch('showLoading');
        let response = await createOrder(this.order);
        const analytics = getAnalytics();
        logEvent(analytics, 'begin_checkout', {
          currency: 'TWD',
          value: this.totalPrice,
          items: shopping_carts.map(item => ({
            item_id: item.commodity_id,
            item_name: item.name,
            item_category: item.category,
            price: item.price,
            quantity: item.amount,
          })),
        });
        if (await checkError(this.$dialog, response)) {
          // this.$emit('orderData', response.data.order);
          let order = response.data.order;
          await this.$store.dispatch('hideLoading');
          this.$router.push({path: '/orderDetail', query: {trade_no: order.trade_no}});
        }
      } catch (e) {
        console.log('error ', e);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.order_list {
  width: 1120px;
  margin: 0 auto;
}

@media (max-width: 1440px) {
  .order_list {
    width: 77vw;
  }
}

@media (max-width: 1024px) {
  .order_list {
    width: 90vw;
  }
}

@media (max-width: 576px) {
  .order_list {
    width: 100%;
  }
}


.label_title {
  background-color: #333333;
  padding: 10px 24px 10px 24px;
  color: white;
  font-size: 20px;
  font-weight: 500;
}

.commodity_label {

}

@media (max-width: 768px) {
  .commodity_label {
    height: 0;
    visibility: hidden;
  }
}

.commodity_label_space {
  height: 24px;
}

@media (max-width: 768px) {
  .commodity_label_space {
    height: 0;
  }
}

.count_area {
  max-width: 280px;
  width: 280px;
  justify-content: space-between;
  padding-right: 60px;
}

@media (max-width: 1024px) {
  .count_area {
    width: 35%;
    padding-right: 5vw;
  }
}

.order_list .info_area {
  padding-left: 24px;
  padding-right: 24px;
}

@media (max-width: 1024px) {
  .order_list .info_area {
    padding-left: 16px;
    padding-right: 16px;
  }
}


.info_area {
  background-color: #FAFAFA;
}

.amount_area {
  width: 270px;
  justify-content: space-between;
}

.text_style {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  color: #333333;
}

.input_area {
  padding-left: 0;
  padding-right: 0;
}


.text_label {
  max-width: 160px;
  width: 160px;
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

@media (max-width: 425px) {
  .text_label {
    font-size: 16px;
    min-width: 112px;
    width: 30%;
  }
}


.must {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #D56835;
}

@media (max-width: 425px) {
  .must {
    font-size: 16px;
  }
}

.input_style {
  font-family: Noto Sans TC;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #333333;
  padding: 12px;
  //border-radius: 5px;
  border: 0.5px solid #DDE1E9;
  resize: none; /* 禁用用户调整大小 */
  overflow: auto; /* 确保超出内容时可以滚动 */
  width: 100%;
}

.input_style::placeholder {
  color: #888;
}


.error-message {
  color: #D60404;
  font-size: 14px;
  margin-top: 8px;
  margin-left: 8px;
}

@media (max-width: 425px) {
  .error-message {
    margin-top: 4px;
    margin-left: 4px;
    //font-size: 16px;
  }
}

.divider {
  width: auto;
  height: 1px;
  background-color: #D56835;
}

.subtotal {
  width: 50%;
  margin: 0 0 0 auto;
  padding-right: 24px;
}


@media (max-width: 1024px) {
  .subtotal {
    width: 100%;
    margin: 0;
  }
}


.subtotal_label {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  color: #333333;
}

.price {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-align: right;
  color: #333333;
}

.total_price {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-align: right;
  color: #D56835;
}

@media (max-width: 425px) {
  .total_price {
    font-size: 20px;
  }
}

.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-family: Noto Sans TC;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: left;
  color: #333333;

}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 50%;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: white; /* 背景顏色 */
  border: 2px solid #D56835; /* 邊框顏色和寬度 */
  border-radius: 3px; /* 邊框圓角 */
  transform: translateY(-50%);
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #D56835;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}


.btn_area {
  text-align: end;
  padding-right: 10px;
}

@media (max-width: 425px) {
  .btn_area {
    padding: 0;
    margin: 0;
  }
}

.btn_style {
  width: 230px;
  height: 56px;
  line-height: 0;
}

@media (max-width: 700px) {
  .btn_style {
    width: 200px;
    height: 48px;
  }
}

@media (max-width: 425px) {
  .btn_style {
    width: 120px;
    height: 32px;
  }
}

.btn_text {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  color: white;
}

@media (max-width: 425px) {
  .btn_text {
    line-height: 0;
    font-weight: 500;
    font-size: 16px;
  }
}

</style>
